import { useEventFundraisingQuery } from './useDashboardQueries';
import FundraisingStats from './FundraisingStats';
import UI from '../../common/UI';

export interface EventFundraisingDashboardPageProps {
  eventId: string;
}

const EventFundraisingDashboardPage = ({ eventId }: EventFundraisingDashboardPageProps) => {
  const { event } = useEventFundraisingQuery(eventId);

  if (!event) {
    return <UI.PageLoader />;
  }

  return (
    <>
      <FundraisingStats event={event} />
    </>
  );
};

export default EventFundraisingDashboardPage;
